var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 47.03 56.441",
    style: {
      enableBackground: "new 0 0 47.03 56.441"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EBEBEB;}\n\t.st1{fill:none;stroke:#4FB8C2;stroke-width:2;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#4FB8C2;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#4FB8C2;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#4FB8C2;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:#4FB8C2;}\n\t.st6{fill:#404040;}\n\t.st7{fill:#FFFFFF;}\n\t.st8{fill:none;stroke:#4FB8C2;stroke-miterlimit:10;}\n\t.st9{enable-background:new    ;}\n\t.st10{fill:#303B84;}\n\t.st11{fill:#A7DBE0;}\n\t.st12{fill:none;stroke:#4FB8C2;stroke-width:2.5;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st13{fill:none;stroke:#404040;stroke-miterlimit:10;}\n\t.st14{fill:#B3B3B3;}\n\t.st15{fill:#FF3732;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M14.486,9.275V4.5c0-1.925,1.575-3.5,3.499-3.5h11.059c1.926,0,3.5,1.575,3.5,3.5v4.775"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M42.238,14.824l-1.403,36.62c-0.085,2.198-1.953,3.997-4.153,3.997h-25.5c-2.2,0-4.105-1.797-4.234-3.993 L4.793,14.824"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 1,
    y1: 9.487,
    x2: 46.03,
    y2: 9.487
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 23.514,
    y1: 49.536,
    x2: 23.514,
    y2: 14.725
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 31.504,
    y1: 49.536,
    x2: 32.455,
    y2: 14.699
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 14.575,
    y1: 14.739,
    x2: 15.556,
    y2: 49.536
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.df2c9078d397584d67a09bea82d403e2.svg";
export { ForwardRef as ReactComponent };